import React from 'react';
import TranslationTime from '../../Translation/cont/TranslationTime';
import TextValueField from '../general/TextValueField';
import EditEventFormSingleType from './EditEventFormSingleType';
import EditEventFormTypeWrapper from './EditEventFormTypeWrapper';

const EditEventMetaData = ({ values, activeField, setActiveField, getStatusSettings, created_at, updated_at, eventName }) => {
    return (
        <div className='meta-data-box'>
            <EditEventFormTypeWrapper headline={'Name des Events'}>
                <TextValueField
                    name={'name'}
                    type={'text'}
                    withLineBreak={false}
                    formValue={values.name}
                    currValue={values.name}
                    activeField={activeField}
                    setActiveField={setActiveField}
                />
            </EditEventFormTypeWrapper>

            <EditEventFormSingleType
                headline="Status des Events"
                fieldName={'status'}
                keyName="name"
                keyId="id"
                currValue={values.status}
                formValue={values.status}
                settings={getStatusSettings()}
                activeField={activeField}
                setActiveField={setActiveField}
            />

            <EditEventFormTypeWrapper headline={'Anfrage-Nummer'}>
                <p className='text-small-light'>{eventName}</p>
            </EditEventFormTypeWrapper>

            <EditEventFormTypeWrapper headline={'Datum der Anfrage'}>
                <p className='text-small-light'><TranslationTime id="dateWithDay" timeString={created_at} /></p>
            </EditEventFormTypeWrapper>

            <EditEventFormTypeWrapper headline={'zuletzt bearbeitet am'}>
                <p className='text-small-light'><TranslationTime id="dateWithDay" timeString={updated_at} /></p>
            </EditEventFormTypeWrapper>
        </div>
    );
}

export default EditEventMetaData;